import { ModalContent } from '@/components/Modal'
import { Body } from './Body'
import { Header } from './Header'

import { useConfigureController } from '../hooks/useController'
import { BodyLoading } from './BodyLoading'

type Props = {
  recurrentOrderId: string
  date: string
  type: uui.domain.client.rm.OrderStepIdentifier
}

export function Content(props: Props) {
  const { recurrentOrderId, date, type } = props
  const {
    ready,
    data: { loadingData },
  } = useConfigureController(recurrentOrderId, date, type)

  if (!recurrentOrderId || !ready) return null

  return (
    <ModalContent
      header={<Header />}
      style={{ padding: 0, height: '60vh', display: 'flex', flexDirection: 'column' }}
    >
      {loadingData ? <BodyLoading /> : <Body />}
    </ModalContent>
  )
}
